import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TeachersReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { TeachersReportApi } from '../api/teachers-reports-api';
import { TeachersReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class TeachersReportRepository extends Repository {
  constructor(private teachersReportApi: TeachersReportApi) {
    super();
  }

  getTeachersReport(filter: TeachersReportFilterForm): Observable<DataWithPagination<TeachersReport[]>> {
    return this.teachersReportApi.getTeachersReport(filter)
  }
}
